import { TAG_TYPES } from "@seneca/tags-service-consts";

import { getClient } from "services";

import { updateTag as updateTagAction } from "../state/admin";

export function makeUpdateTag(updateActionFactory: any) {
  const updateTag = updateActionFactory({
    requestFunction: ({ id, ...rest }: any) =>
      getClient("tagService").updateTag(id, {
        type: TAG_TYPES.tag,
        ...rest
      }),
    storeAction: updateTagAction
  });

  const updateCategory = updateActionFactory({
    requestFunction: ({ id, ...rest }: any) =>
      getClient("tagService").updateTag(id, {
        type: TAG_TYPES.category,
        ...rest
      }),
    storeAction: updateTagAction
  });

  return {
    updateTag,
    updateCategory
  };
}
